import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { defaults, filter, includes, uniq, without } from 'lodash';
import { map, Observable } from 'rxjs';

import { CobMetaService } from '@lockton-apps/shared/util/constants';
import {
  ProposalQuickRaterQuote,
  ProposalQuickRaterQuotes,
} from '@lockton-apps/shared/interfaces';

interface ProposalLocalState {
  quotes: ProposalQuickRaterQuotes;
  loadingIds: string[];
  additionalProductsIds: string[];
}

const defaultState: ProposalLocalState = {
  quotes: {},
  loadingIds: [],
  additionalProductsIds: [],
};

@Injectable()
export class ProposalLocalStore extends ComponentStore<ProposalLocalState> {
  constructor(private cobMetaService: CobMetaService) {
    super(defaultState);
  }

  readonly quotes$: Observable<ProposalQuickRaterQuotes> = this.select(
    (state) => state.quotes
  );

  readonly loadingIds$: Observable<string[]> = this.select(
    (state) => state.loadingIds
  );

  readonly additionalProductsIds$: Observable<string[]> = this.select(
    (state) => state.additionalProductsIds
  );

  get quotes(): ProposalQuickRaterQuotes {
    return this.get().quotes;
  }

  get loadingIds(): string[] {
    return this.get().loadingIds;
  }

  addLoadingId(id: string) {
    this.patchState((state) => ({
      ...state,
      loadingIds: uniq([...state.loadingIds, id]),
    }));
  }

  updateQuote(quote$: Observable<ProposalQuickRaterQuote>): void {
    this.patchState(
      quote$.pipe(
        map((quote: ProposalQuickRaterQuote) => ({
          quotes: defaults(
            {
              [this.cobMetaService.getClassOfBusinessId(
                quote.classOfBusinessId
              )]: quote,
            },
            this.quotes
          ),
          loadingIds: without(
            this.loadingIds,
            this.cobMetaService.getClassOfBusinessId(quote.classOfBusinessId)
          ),
        }))
      )
    );
  }

  setAdditionalProductsIds(additionalProductsIds: string[]): void {
    this.patchState({
      additionalProductsIds,
      quotes: filter(this.quotes, (_, id) =>
        includes(additionalProductsIds, id)
      ) as unknown as ProposalQuickRaterQuotes,
    });
  }
}
